export default __webpack_public_path__ + "images/TEZ.dd145a3.png";